import React, { useState, useEffect, useReducer, useRef } from "react";
import TextBox from "devextreme-react/text-box";
import ScrollView from "devextreme-react/scroll-view";
import TextArea from "devextreme-react/text-area";
import Button from "devextreme-react/button";
import FileUploader from "devextreme-react/file-uploader";
import WhiteBoard from "../common/WhiteBoard/WhiteBoard";
import rpsReducer from "../../reducers/rps";
import { downloadOphFile } from "../../actions/rps";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import * as action from "../../actions/rps";
import NEXUS_CONST from "../../common/constants";
import * as utils from "../../common/utils";
import { getTypeOfFile, onDownloadFile } from "../../common/utils";
import { confirm } from "devextreme/ui/dialog";
import RadioGroup from "devextreme-react/radio-group";
import { alert } from "devextreme/ui/dialog";
import ACTION_TYPES from "../../actions/actionTypes";
import { postUserLog } from "../../actions/common";
import { INDE } from "./config";
import config from "../../common/config";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";

const initialStates = { ophFile: null };

const BreakdownProblem = (props) => {
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  const [selectedcontainment, setselectedcontainment] = useState(false);
  const [epointcause, setepointcause] = useState("");
  const [containmentchecked, setcontainmentchecked] = useState(false);
  const [showcontainmentbox, setshowcontainmentbox] = useState(false);
  const [whiteBoardData, setWhiteBoardData] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [containmentvalue, setcontainmentvalue] = useState(false);
  const [image, setImage] = useState(null);
  const [enableSave, setEanbleSave] = useState(false);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });

  let wbIs, wbRc;
  let { rpsAllData, ophFile, breakdownAttachmentData } = state;
  const wBRc = (k) => {
    wbRc = k;
  };
  const wBIs = (k) => {
    wbIs = k;
  };
  const [WBOpen, setWBOpen] = useState(false);
  const [WBRc, setWBRc] = useState(false);
  const deleteFile = (id) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );
    confirm_it.then((res) => {
      if (res) {
        AsyncCallHandler(
          NEXUS_CONST.DELETE_RESULTS_ATTACHMENT_DATA + id,
          NEXUS_CONST.POST
        ).then((res) => {
          action.breakdownGetAttachmentsData(
            dispatch,
            props.rpsID,
            "Breakdown"
          );
        });
      } else {
        return false;
      }
    });
  };
  useEffect(() => {
    utils.set("wbData_is", { objects: [] });
    action.fetchProblemSovingDatabyId(dispatch, props.rpsID);
    action.breakdownGetAttachmentsData(dispatch, props.rpsID, "Breakdown");
    AsyncCallHandler(
      NEXUS_CONST.FETCH_PS_DATA + props.rpsID,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        let subModuleName = "";
        setepointcause(res.data.initialState);
        setEanbleSave(res?.data?.status === "Complete");
        setcontainmentchecked(res.data.isContainment);
        {
          res.data.isContainment === true
            ? setshowcontainmentbox(true)
            : setshowcontainmentbox(false);
        }
        if (res?.data?.metric === "Survey") {
          subModuleName = `${res?.data?.subModuleID}:${res?.data?.subModule}`;
        } else subModuleName = res?.data?.subModuleID;

        if (res?.data?.metric !== INDE)
          action.fetchCommonParetoData(
            dispatch,
            `${props.siteId}&tierid=${props.tierId}&moduleName=${res?.data?.metric}&subModuleName=${subModuleName}`
          );

        setcontainmentvalue(res.data.containment);
      }
    });
  }, []);
  const savebreakdown = () => {
    setEanbleSave(true);
    let rootCauseWB =
      whiteBoardData == "" ? rpsAllData?.rootCauseWhiteBoard : whiteBoardData;
    let initialStateWB = utils.get("wbData_is")
      ? JSON.stringify(utils.get("wbData_is"))
      : { objects: [] };
    let payload = {
      rpsid: props.rpsID,
      tierid: props.tierid,
      InitialState: epointcause,
      InitialStateWhiteBoard: initialStateWB,
      IsContainment: selectedcontainment,
      Containment: containmentvalue,
      lastSavedTab: "2",
    };
    let totalFileSize = selectedFiles?.reduce((acc, cur) => {
      return (acc = acc + cur.size);
    }, 0);
    if (epointcause != null) {
      if (epointcause.length == 0) {
        setEanbleSave(false);
        alert("Please enter value marked mandatory", "Alert");
        return false;
      }
    }
    if (epointcause == null) {
      setEanbleSave(false);
      alert("Please enter value marked mandatory", "Alert");
      return false;
    }

    if (containmentchecked == true && containmentvalue == null) {
      setEanbleSave(false);
      alert("Please enter value marked mandatory", "Alert");
      return false;
    }
    if (containmentchecked == true && containmentvalue != null) {
      if (containmentvalue.length == 0) {
        setEanbleSave(false);
        alert("Please enter value marked mandatory", "Alert");
        return false;
      }
    }
    if (selectedFiles?.length > 0 && totalFileSize > 4000000) {
      setEanbleSave(false);
      alert(
        "Please fill all required fields and<br/> Make sure sum of uploaded files size is less than 4MB"
      );
      return false;
    }

    // Check files are valid or not
    const validateUploadFiles = checkUploadFilesValid(
      selectedFiles,
      ALLOWED_MIME_TYPES
    );
    setEanbleSave(false);
    if (validateUploadFiles.length) {
      const alertMsg = validateUploadFiles.map(
        (file) => `${file.name} - ${file.reason}`
      );
      alert(alertMsg.join("<br/>"), "Alert");
      return false;
    }

    AsyncCallHandler(
      NEXUS_CONST.MANAGE_PS_DATA,
      NEXUS_CONST.POST,
      payload
    ).then((res) => {
      if (res) {
        if (selectedFiles?.length === 0) {
          setEanbleSave(false);
        }
        action.breakdownGetAttachmentsData(dispatch, props.rpsID, "Breakdown");
        props.handleSPSSave();
        postUserLog({
          event: "Box 2 - Breakdown the Problem",
          data: {
            action: `PS-${props.rpsID} Saved`,
            module: "Digital Tier",
            section: props.navigationOn,
            siteUId: props.siteId,
            widget: "Structured Problem Solving",
            tierId: props.tierId,
          },
        });
      }
    });
    let formData = new FormData();
    if (rpsAllData?.vsTabs[2].isSaved === false) {
      ophFile && formData.append("paretoFile", ophFile.file);
      if (selectedFiles?.length > 0) {
        if (
          selectedFiles &&
          selectedFiles.length &&
          Array.isArray(selectedFiles)
        ) {
          selectedFiles.forEach((file) => {
            formData.append("files", file);
          });
        }
      }
      formData.append("rpsId", props.rpsID ? props.rpsID : 1);
      formData.append("tierID", props.tierId);
      formData.append("attachmentType", "Breakdown");
      formData.append("section", props.navigationOn);
      AsyncCallHandler(
        NEXUS_CONST.PUT_CONFIRMRESULT_ATTACHMENT,
        NEXUS_CONST.PUT,
        formData
      ).then((res) => {
        setEanbleSave(false);
        dispatch({
          type: ACTION_TYPES.PUT_CONFIRMRESULT_ATTACHMENT,
          payload: res.data,
        });
        action.breakdownGetAttachmentsData(dispatch, props.rpsID, "Breakdown");
        action.fetchProblemSovingDatabyId(dispatch, props.rpsID);
        setSelectedFiles([]);
      });
    } else {
      if (selectedFiles?.length > 0) {
        if (
          selectedFiles &&
          selectedFiles.length &&
          Array.isArray(selectedFiles)
        ) {
          selectedFiles.forEach((file) => {
            formData.append("files", file);
          });
        }

        formData.append("rpsId", props.rpsID ? props.rpsID : 1);
        formData.append("tierID", props.tierId);
        formData.append("attachmentType", "Breakdown");
        AsyncCallHandler(
          NEXUS_CONST.PUT_CONFIRMRESULT_ATTACHMENT,
          NEXUS_CONST.PUT,
          formData
        ).then((res) => {
          setEanbleSave(false);
          dispatch({
            type: ACTION_TYPES.PUT_CONFIRMRESULT_ATTACHMENT,
            payload: res.data,
          });
          action.breakdownGetAttachmentsData(
            dispatch,
            props.rpsID,
            "Breakdown"
          );
          action.fetchProblemSovingDatabyId(dispatch, props.rpsID);
          setSelectedFiles([]);
          props.setisOpen("2");
        });
      }
    }
    props.handleSPSSave();
    props.setisOpen("2");
  };

  useEffect(() => {
    utils.set(
      "wbData_is",
      rpsAllData && rpsAllData.initialStateWhiteBoard
        ? JSON.parse(rpsAllData.initialStateWhiteBoard)
        : { objects: [] }
    );
  }, [rpsAllData]);

  const onOphFile = () => {
    action.downloadOphFile(
      ophFile.file,
      "digitaltier/DownloadExcelFile?filename=" + ophFile.file
    );
  };

  const onFileSelect = (e) => {
    setSelectedFiles(e.value);
    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
  };

  const handlpointcause = (e) => {
    setepointcause(e.value);
  };
  const onchangecontainment = (event) => {
    setselectedcontainment(event.target.value);
    {
      event.target.value === "0"
        ? setshowcontainmentbox(true)
        : setshowcontainmentbox(false);
    }
  };

  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 2 - &nbsp;</span>Breakdown the Problem
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={enableSave}
            width={200}
            onClick={savebreakdown}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView
        width="100%"
        height="420px"
        className="sps-box-s"
        id="scrollview"
        //   {...scrollConfig}
      >
        <div className="gridavailable">
          <TextArea
            label="Establish point of cause *"
            labelMode="floating"
            value={epointcause}
            onValueChanged={handlpointcause}
            wordWrapEnabled={true}
            className="dx-field-text"
            maxLength={700}
          ></TextArea>

          { config.DEV_DISPLAY_OPTIONS && <div className="wb-act-blk no-print">
            <Button
              className="rps-wb-btn"
              type="normal"
              onClick={() => setWBRc(!WBRc)}
            >
              <span className="icon whiteboard wh-50"></span>
            </Button>
          </div> }
          {
            <>
              {WBRc && (
                <div className="no-print">
                  <WhiteBoard
                    siteId={props.siteId}
                    isRps={true}
                    wbRef={wBIs}
                    rpsData={utils.get("wbData_is")}
                    widgetId={"is"}
                  />
                </div>
              )}
            </>
          }
          <div style={{ display: "flex" }}>
            <div style={{ width: "43%" }} className="no-print">
              <div className="dx-field no-print">
                <div className="dx-field-label">Initial State Attachment</div>
                <div
                  className="clickable-hover"
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                  onClick={onOphFile}
                >
                  {ophFile && rpsAllData?.vsTabs[2].isSaved === false
                    ? ophFile.file
                    : ""}
                </div>

                <FileUploader
                  className="dx-field-value gridavailable"
                  selectButtonText="Choose file"
                  labelText="Max. File Size 4 MB"
                  accept="*"
                  uploadMode="uploadUrl"
                  multiple={true}
                  onValueChanged={onFileSelect}
                  value={selectedFiles}
                  allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
                />
              </div>
              {breakdownAttachmentData &&
                breakdownAttachmentData.map((item) => (
                  <div>
                    <a
                      style={{ cursor: "pointer" }}
                      className="clickable-hover"
                      onClick={() => {
                        getTypeOfFile(
                          {
                            imageName: item?.attachmentName,
                            folderName: "RPS",
                            subfolderName: "Breakdown",
                            fileExtension: "xls",
                          },
                          "RPS"
                        );
                      }}
                    >
                      {" "}
                      {item?.attachmentName}{" "}
                    </a>
                    <span className="rca_download">
                      <i
                        title="Download"
                        className="fa fa-download pointer"
                        onClick={() =>
                          onDownloadFile(
                            item?.attachmentName,
                            "RPS",
                            "Breakdown"
                          )
                        }
                      ></i>
                    </span>
                    <span
                      className="rca_delete"
                      style={{ padding: "0px 15px 0px 10px" }}
                    >
                      <i
                        title="Delete"
                        className="fas fa-trash pointer"
                        onClick={() => deleteFile(item.id)}
                      ></i>
                    </span>
                  </div>
                ))}
            </div>
            <div
              style={{ width: "48%" }}
              onChange={(value) => {
                onchangecontainment(value);
              }}
            >
              <span>{`Do we need containment? ${
                containmentchecked ? "*" : ""
              }`}</span>
              <RadioGroup
                items={[
                  { id: true, text: "Yes" },
                  { id: false, text: "No" },
                ]}
                value={containmentchecked}
                valueExpr="id"
                displayExpr="text"
                onValueChanged={(e) => {
                  setcontainmentchecked(e.value);
                  //setshowcontainmentbox(e.value);
                  setselectedcontainment(e.value);
                }}
                layout="horizontal"
              />

              {containmentchecked && containmentchecked === true && (
                <TextBox
                  label=""
                  labelMode="floating"
                  value={containmentvalue}
                  maxLength={700}
                  wordWrapEnabled={true}
                  onValueChanged={(e) => {
                    setcontainmentvalue(e.value);
                  }}
                  className="dx-field-text"
                ></TextBox>
              )}
            </div>
          </div>
        </div>
      </ScrollView>
    </>
  );
};
export default BreakdownProblem;
